import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageLayout } from '@thinknet-gmbh/platform-common-ui';
import { useGetKWPConnectionByUserId } from 'src/hooks/interfaces/kwp/get-kwp-connection.hook';
import { DasboardContainer } from './dashboard.styles';
import AbsencesWidgetContainer from './components/widgets/absences-widget.component';
import WorkloadWidgetContainer from './components/widgets/workload-widget.component';
import ProjectsWidgetContainer from './components/widgets/projects-widget.component';
import { getKwpTokenFromAPI } from '../settings/components/interfaces/kwp/components/helpers';

const Dashboard: React.FC = () => {
  const { t } = useTranslation('dashboard');
  const [searchParams] = useSearchParams();
  const codeParamFromURL = searchParams.get('code');

  const connectionData = useGetKWPConnectionByUserId();

  useEffect(() => {
    if (codeParamFromURL && connectionData.interfaceConnection) {
      getKwpTokenFromAPI(
        codeParamFromURL,
        connectionData.interfaceConnection.link,
        connectionData.interfaceConnection.codeVerifier
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [connectionData, codeParamFromURL, searchParams]);

  return (
    <PageLayout pageTitle={t('labels.title')} className="dashboard-layout">
      <DasboardContainer>
        <AbsencesWidgetContainer t={t} />
        <WorkloadWidgetContainer t={t} />
        <ProjectsWidgetContainer t={t} />
      </DasboardContainer>
    </PageLayout>
  );
};

export default Dashboard;
